import React from "react";
import { Link } from "react-router-dom";

export default class ReferenceTabs extends React.Component {
  isAccessible = (tab) => {
    if (!tab.visible) return false;
    if (Array.isArray(tab.items)) {
      return tab.items.some((itemKey) =>
        this.props.isAccessible(itemKey, true)
      );
    }
  };

  render() {
    const { tabs, tabId } = this.props;
    return (
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item w-lg-auto w-100">
          <Link
            to={`/reference/`}
            className={` ${!tabId ? "active" : ""} cursor-pointer nav-link`}
          >
            Все
          </Link>
        </li>
        {Object.entries(tabs).map(([id, tab]) => (
          <React.Fragment key={id}>
            {this.isAccessible(tab) && (
              <li className="nav-item w-lg-auto w-100" key={id}>
                <Link
                  to={`/reference/${id}/`}
                  className={` ${
                    tabId === id ? "active" : ""
                  } cursor-pointer nav-link`}
                >
                  {tab.label}
                </Link>
              </li>
            )}
          </React.Fragment>
        ))}
      </ul>
    );
  }
}
